// extracted by mini-css-extract-plugin
module.exports = {"error":"CommonTextError_error__yAnvh","errorCentered":"CommonTextError_errorCentered__zcDve"};